import Offcanvasnav from "../components/OffCanvas/OffCanvas";
import Table from "react-bootstrap/Table";
import styled from "styled-components";
import { Helmet } from "react-helmet-async";
// For test and dev
// import { AppointmentDates } from "../domain/appointments/exampleAppointmentDates";
// For real site
import { AppointmentDates } from "../domain/appointments/AppointmentDates";
import { Appointments } from "../components/Appointments/Appointments";
import SetSeoMeta from "../components/Seo/Seo";

export default function AppointmentsPage() {
  return (
    <>
      <SetSeoMeta
        title='1731 - Termine'
        description='Hier findest Du alle unsere Termine und einige Termine anderer Gilden'
        name='Totengilde Blekendorf von 1731'
        type='article'
      />
      <BackgroundDiv>
        <BackgroundInnerDiv>
          <Offcanvasnav></Offcanvasnav>
          <h1
            style={{
              textAlign: "center",
              color: "#052186",
              fontSize: "4rem",
              paddingTop: "0.5rem",
            }}
          >
            Termine
          </h1>
          <AppointmentsDiv>
            <StyledTable striped bordered hover>
              <thead>
                <tr>
                  <th
                    style={{ backgroundColor: "#ffffff95", fontSize: "1.5rem" }}
                  >
                    Datum
                  </th>
                  <th
                    style={{ backgroundColor: "#ffffff95", fontSize: "1.5rem" }}
                  >
                    Was
                  </th>
                  <th
                    style={{ backgroundColor: "#ffffff95", fontSize: "1.5rem" }}
                  >
                    Wer
                  </th>
                  <th
                    style={{ backgroundColor: "#ffffff95", fontSize: "1.5rem" }}
                  >
                    Wo
                  </th>
                  <th
                    style={{ backgroundColor: "#ffffff95", fontSize: "1.5rem" }}
                  >
                    Kontakt
                  </th>
                </tr>
              </thead>
              <Appointments appointments={AppointmentDates} />
              {/* Details Parken Adr */}
            </StyledTable>
          </AppointmentsDiv>
        </BackgroundInnerDiv>
      </BackgroundDiv>
    </>
  );
}

const BackgroundDiv = styled.div`
  background-image: url("images/kk_cut_web_50.jpg") !important;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-cover: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-position-y: top;
  max-height: 100vh;
  // width: 100%;
  // margin: 0;
  // @media (min-width: 1250px) {
  //   background-size: 100%;
  // }
  /* border: 2px red solid; */
`;

const BackgroundInnerDiv = styled.div`
  background: linear-gradient(
    #ffffff10 0%,
    /* #ffffffb2 50%,
    #ffffffbd 80%,
    #ffffffdb 95%, */ #ffffffe9 100%
      /* red 10%, 30%, blue 90% */
  );
  height: 100vh;
  /* border: 2px solid blue; */
`;

const AppointmentsDiv = styled.div`
  min-width: 50%;
  /* margin: auto; */
  padding: 1rem 4rem;
  text-align: center;
  /* border: 2px orange solid; */
`;

// No More Tables
const StyledTable = styled(Table)`
  @media only screen and (max-width: 800px) {
    /* Force table to not be like tables anymore */
    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      border: 1px solid #66c4fa7a;
    }

    td {
      /* Behave  like a "row" */
      border: none;
      border-bottom: 1px solid #dadada;
      position: relative;
      /* padding-left: 50%; */
      padding-left: 6.5rem;
      white-space: normal;
      text-align: left;
    }

    td:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 6px;
      left: 6px;
      max-width: 45%;
      padding-right: 10px;
      white-space: nowrap;
      text-align: left;
      font-weight: bold;
    }

    td {
      border: none !important;
    }

    /*
	Label the data
	*/
    td:before {
      content: attr(data-title);
    }
  }
`;
